<template>
  <div id="about" class="address-delivery-main flex flex-align-items-start">
    <div class="address-delivery-main-items">
      <h2 class="vz-text-align-left">
        Закажите адресную доставку по всей России
      </h2>
      <div class="address-delivery-main-item flex flex-align-items-start mb-30" v-for="item in items">
        <vz-icon
          :url="item.iconUrl"
          size="36"
          no-masked-icon
          variant="primary"
          class="mr-10"
        />
        <div class="address-delivery-main-item-wrapper">
          <span class="mt-5">{{ item.title }}</span>
          {{ item.text }}
        </div>
      </div>
    </div>
    <public-card-attention :text="text" text-left class="ml-20"/>
  </div>
</template>

<script setup lang="ts">
import PublicCardAttention from '~/components/public/public-card-attention.vue'
import {getPageContent} from '~/api/content';

const data = (await getPageContent('/address-delivery')).blocks?.about

const text = data.attention
const items = computed(() => [
  {
    iconUrl: '/svg/car/truck.svg',
    title: data.pickupTitle,
    text: data.pickupText,
  },
  {
    iconUrl: '/svg/address-address.svg',
    title: data.deliveryTitle,
    text: data.deliveryText,
  }
])
</script>

<style lang="scss" scoped>
  .address-delivery-main {
    margin-top: 70px;

    @media only screen and (max-width: $pub-sm) {
      margin-top: 50px;
    }

    @media only screen and (max-width: $pub-xs) {
      flex-direction: column;
    }

    &-items {
      @media only screen and (max-width: $pub-sm) {
        max-width: 485px;
        width: 100%;
      }

      @media only screen and (max-width: $pub-xs) {
        max-width: none;
      }
    }

    &-item-wrapper {
      span {
        display: block;
        margin-bottom: 10px;
        font-weight: 700;
      }
    }

    :deep(.public-card-attention) {
      padding: 40px;

      @media only screen and (max-width: $pub-sm) {
        margin-left: 10px;
        padding: 45px 20px;
      }

      @media only screen and (max-width: $pub-xs) {
        margin-left: 0;
        padding: 30px;
      }

      ul {
        margin-left: 30px;
      }

      a {
        color: $white;
        text-decoration: underline;
      }
    }
  }
</style>
